import React, { useEffect, useState } from "react";

export const themeContext = React.createContext();

const ThemeContext = (props) => {
    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const currentTheme = localStorage.getItem("data-theme");
        const defaultTheme = "light";
        if (currentTheme === null || currentTheme === undefined) {
            const currentTheme = defaultTheme;
            localStorage.setItem("data-theme", defaultTheme);
            document.documentElement.setAttribute("data-theme", defaultTheme);
            setTheme(currentTheme);
        } else {
            setTheme(currentTheme);
            document.documentElement.setAttribute("data-theme", currentTheme);
        }
    }, []);

    const handleTheme = () => {
        let currentTheme = "";
        theme === 'light' ? currentTheme = 'dark' : currentTheme = 'light';
        setTheme(currentTheme);
        localStorage.setItem("data-theme", currentTheme);
        document.documentElement.setAttribute("data-theme", currentTheme);
    };

    const contextValue = {
        theme,
        setTheme,
        handleTheme,
    };
    return (
        <themeContext.Provider value={contextValue}>
            {props.children}
        </themeContext.Provider>
    );
};

export default ThemeContext;
